import { gql } from "@apollo/client";

/**
 * GraphQL Query - Infrastructure layer
 * Fetches a single organization by id (number) with brands and brand features.
 */
export const GET_ORGANIZATION_DETAILS = gql`
  query OrganizationDetails($organizationId: Float!) {
    organizationDetails(organizationId: $organizationId) {
      organizationId
      organizationKey
      organizationName
      organizationDisplayName
      organizationDescription
      organizationLogoUrl
      organizationIsActive
      organizationCreatedAt
      organizationUpdatedAt
      organizationDeletedAt
      organizationCreatedBy
      organizationUpdatedBy
      organizationDeletedBy
      brands {
        brandId
        brandKey
        brandName
        brandDisplayName
        brandDescription
        brandLogoUrl
        brandIsActive
        brandCreatedAt
        brandUpdatedAt
        brandDeletedAt
        brandCreatedBy
        brandUpdatedBy
        brandDeletedBy
        brandFeaturesCount
        brandFeatures {
          brandFeatureId
          brandFeatureKey
          brandFeatureName
          brandFeatureDescription
          brandFeatureIsActive
          brandFeatureIsMainMenu
          brandFeatureMappingId
          brandFeatureMappingCreatedAt
          brandFeatureMappingCreatedBy
        }
      }
    }
  }
`;
